import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { useSupporterVideos } from '../../../../../../hooks/supporterVoices/supporterVideos';

import { CreateVideo } from './components/CreateVideo';
import { VideoComponent } from './components/VideoComponent';
import { ViewPetitionFeed } from './components/ViewPetitionFeed';

export function SupporterVoicesVideos(): React.JSX.Element | null {
	const {
		data: {
			petition: { id: petitionId, slug },
			supporterVoicesVideos,
		},
	} = usePetitionDetailsPageData();

	const {
		data: { currentlyPlaying, supporterVideos, showCreateVideo },
		actions: { setCurrentlyPlaying, removeVideoFromState },
	} = useSupporterVideos({ supporterVoicesVideos });

	if (supporterVideos.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-col gap-6">
			<Text as="h3" fontWeight="normal" size="x-large" variant="body">
				<Translate value="corgi.petition_gamma.videos.title" />
			</Text>

			<div className="relative max-w-full overflow-x-auto overflow-y-hidden py-6">
				<div className="flex flex-row gap-4">
					{supporterVideos.map((video) => {
						return (
							<div key={video.id} className="shrink-0">
								<VideoComponent
									className="h-[320px] object-cover"
									video={video}
									currentlyPlaying={currentlyPlaying}
									setCurrentlyPlaying={setCurrentlyPlaying}
									removeVideoFromState={removeVideoFromState}
								/>
							</div>
						);
					})}
					{showCreateVideo && <CreateVideo />}
				</div>
			</div>

			<ClientRender>
				<ViewPetitionFeed petitionId={petitionId} slug={slug} />
			</ClientRender>
		</div>
	);
}
